// 通用GET请求方法
export const get = async (url, params = {}, options = {}) => {
  try {
    // 构建完整的URL和查询参数
    let fullUrl = url;
    if (params && Object.keys(params).length > 0) {
      const queryString = new URLSearchParams(params).toString();
      fullUrl = `${url}?${queryString}`;
    }

    // 发送GET请求
    const response = await fetch(fullUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        changeOrigin: true,
        ...options.headers
      },
      ...options
    });

    // 检查响应状态
    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status} ${response.statusText}`);
    }

    // 解析JSON响应
    const data = await response.json();

    // 返回标准化结果
    return {
      success: true,
      data: data,
      message: '请求成功',
      status: response.status
    };
  } catch (error) {
    // 统一错误处理
    return {
      success: false,
      data: null,
      message: error.message || '请求失败',
      error: error
    };
  }
};
